import type { ReactNode } from 'react'

import { Divider } from '@twistopayments/design-system/components/atoms/divider'
import { Hidden } from '@twistopayments/design-system/components/atoms/hidden'
import { HelpModalAction } from '@twistopayments/design-system/components/organisms/help-modal'

import { FlowBackOverrideProvider } from '@twisto/flow-views'

import { DebugInfo } from 'flow/components/debug-info'

import { FlowAppBar } from '../../flow-app-bar'

import { OrderInfo } from './order-info'
import * as styles from './pay-in-n-layout.styles'

type Props = {
  children: ReactNode
  withoutDebugInfo: boolean
}

export const PayInNLayout = ({ children, withoutDebugInfo = false }: Props) => (
  <FlowBackOverrideProvider>
    <div css={styles.layout}>
      <FlowAppBar isPayInNLayout />
      <div css={styles.orderInfoContainer}>
        <div css={styles.orderInfoWrapper}>
          <OrderInfo />
        </div>
      </div>
      <Hidden mdUp>
        <Divider />
      </Hidden>

      <div css={styles.footer}>
        <HelpModalAction />
      </div>
      <main css={styles.contentContainer}>
        <div css={styles.contentBox}>{children}</div>
      </main>
      {withoutDebugInfo ? null : <DebugInfo />}
    </div>
  </FlowBackOverrideProvider>
)
